import { PopoverItem } from '@enter/core';
import { mdiChevronDown } from '@mdi/js';
import React, { useState } from 'react';
import * as S from './action-button.styles';

export interface IActionButtonProps {
    className?: string;
    actions?: { label: string; onClick: () => void | Promise<void> }[];
}

export const ActionButton = (props: IActionButtonProps) => {
    const stopPropagation = (e: React.MouseEvent): void => {
        e.stopPropagation();
    };

    const renderButton = (): React.ReactElement => {
        return (
            <S.ActionButton className={props.className}>
                Action
                <S.ActionButtonIcon path={mdiChevronDown} />
            </S.ActionButton>
        );
    };

    return (
        <div onClick={stopPropagation}>
            <S.StyledPopover align="right" renderButton={renderButton}>
                {props.actions?.map((action, i) => (
                    <Action action={action} key={i} />
                ))}
            </S.StyledPopover>
        </div>
    );
};

const Action = ({ action }: { action: { label: string; onClick: () => void | Promise<void> } }) => {
    const [disabled, setDisabled] = useState(false);

    const handleAction = async () => {
        setDisabled(true);

        try {
            await action.onClick();
        } finally {
            setDisabled(false);
        }
    };

    return (
        <PopoverItem onClick={handleAction} disabled={disabled}>
            {action.label}
        </PopoverItem>
    );
};
